import React from 'react';

const LinkList = ({ links, onLinkClick }) => {
  return (
    <div className="link-list">
      <h2>Shortened Links</h2>
      <ul>
        {links.map((link) => (
          <li key={link._id} className="link-item">
            <p>
              <strong>Short URL:</strong>{' '}
              <a
                href={`${window.location.origin}/${link.shortUrl}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`${window.location.origin}/${link.shortUrl}`}
              </a>
            </p>
            <p>
              <strong>Long URL:</strong>{' '}
              <a
                href={link.longUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.longUrl}
              </a>
            </p>
            <p>
              <strong>Clicks:</strong> {link.clicks}
            </p>
            <button onClick={() => onLinkClick(link)}>View Details</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LinkList;
